<div class="system-documentation-page">
  <p-toast />
  
  <div class="content-wrapper flex">
    <div class="table-section col-9 p-3">
      <div class="page-header">
        <div class="header-left">
          <app-back-button
            [title]="template?.title"
            [parentRoute]="parentRoute" />
        </div>
        <div class="flex flex-row gap-2">
          <button
            pButton
            icon="pi pi-download"
            [label]="'Export' | translate"
            class="p-button-primary"
            (click)="exportData()">
          </button>
          <button
            pButton
            icon="pi pi-plus"
            [label]="'Add' | translate"
            class="p-button-primary"
            (click)="openAddModal()">
          </button>
        </div>
      </div>

      @if (apiService) {
        <list-table-without-filters-wrapper
          [columns]="template.table"
          [service]="apiService"
          [getAllMethod]="getDictApiMethodName('GetByQueryPost')"
          [getTotalMethod]="getDictApiMethodName('total')"
          [isLoading]="loading()"
          [storageKey]="null"
          [toggleFilter]="toggleFilter"
          [filtersParams]="filtersParams" />
      }

      @if (lastUpdateTime()) {
        <div class="last-update-info mt-2 p-2 bg-gray-100 rounded text-sm text-gray-600">
          <i class="pi pi-clock mr-1"></i>
          {{ 'Data updated' | translate }}: {{ lastUpdateTime() | date:'dd.MM.yyyy HH:mm:ss' }}
        </div>
      }

      <ng-template #actionsTemplate let-row>
        <div class="flex flex-row">
          <button
            pButton
            class="p-button-text p-button-sm p-button-rounded edit-button"
            (click)="openEditModal(row)"
            [pTooltip]="'Edit' | translate">
            <img src="assets/icons/main/light/edit-2-fill.svg" alt="Edit" class="edit-icon">
          </button>
          <button
            pButton
            icon="pi pi-trash"
            class="p-button-text p-button-sm p-button-danger p-button-rounded"
            (click)="deleteItem(row)"
            [pTooltip]="'Delete' | translate">
          </button>
        </div>
      </ng-template>

      <ng-template #booleanTemplate let-row let-fieldName="fieldName">
        <div class="flex flex-row">
          @if (row[fieldName]) {
            <img
              src="assets/icons/main/light/check-fill.svg"
              alt="Published"
              style="width: 20px; height: 20px;">
          } @else {
            <img
              src="assets/icons/main/light/close-fill.svg"
              alt="Not Published"
              style="width: 20px; height: 20px;">
          }
        </div>
      </ng-template>

      <ng-template #nameTemplate let-row let-fieldName="fieldName">
        <div class="flex flex-column gap-1 names-multilingual">
          <div class="name-item">
            <span class="name-label">UZ:</span>
            <span class="name-value">{{ (row[fieldName] || row.names)?.['uz-Latn-UZ'] || '-' }}</span>
          </div>
          <div class="name-item">
            <span class="name-label">EN:</span>
            <span class="name-value">{{ (row[fieldName] || row.names)?.['en-US'] || '-' }}</span>
          </div>
          <div class="name-item">
            <span class="name-label">RU:</span>
            <span class="name-value">{{ (row[fieldName] || row.names)?.['ru-RU'] || '-' }}</span>
          </div>
        </div>
      </ng-template>

      <ng-template #fileDownloadTemplate let-row>
        <div class="flex flex-row justify-content-left">
          <button
            *ngIf="row['fileStorageId']"
            pButton
            icon="pi pi-download"
            class="p-button-text p-button-sm p-button-rounded"
            (click)="downloadFile(row)"
            [pTooltip]="'Download' | translate">
          </button>
          <span *ngIf="!row['fileStorageId']">-</span>
        </div>
      </ng-template>

      <ng-template #blockTemplate let-row let-fieldName="fieldName">
        <div class="flex flex-row">
          <p>{{ getBlockName(row[fieldName]) }}</p>
        </div>
      </ng-template>
    </div>

    <div class="filters-section col-3">
      <msf-filters
        [fields]="template?.filters"
        [(ngModel)]="filters"
        [metaData]="metaData()"
        (applyFilter)="applyFilters()"
        (clearFilter)="clearFilters()" />
    </div>
  </div>

  <p-dialog
    [(visible)]="showDeleteModal"
    [modal]="true"
    [style]="{width: '400px'}"
    [resizable]="false"
    [draggable]="false"
    [closable]="false">

    <ng-template pTemplate="header">
      <h4 class="dialog-title">
        <i class="pi pi-exclamation-triangle text-orange-500 mr-2"></i>
        {{ 'Confirm Delete' | translate }}
      </h4>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="delete-confirmation-content">
        <p class="mb-3">
          {{ 'Are you sure you want to delete this item?' | translate }}
        </p>
        <p class="text-sm text-gray-600">
          {{ 'This action cannot be undone.' | translate }}
        </p>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="flex flex-row gap-2 justify-end">
        <button
          pButton
          type="button"
          severity="secondary"
          [label]="'No' | translate"
          (click)="cancelDelete()"
          [disabled]="isDeleting()">
        </button>
        <button
          pButton
          type="button"
          severity="danger"
          [label]="'Yes' | translate"
          (click)="confirmDelete()"
          [disabled]="isDeleting()"
          [loading]="isDeleting()">
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>

